import * as React from 'react';
import { connect } from 'react-redux';
import { times as _times } from 'lodash';
import { TroughModel } from 'franke-trough-dependencies';
import { GlobalPrivateState } from 'src/api';
import SelectedTroughListItem from './SelectedTroughListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import './SelectedTroughList.scss';
import TroughMinValues from '../TroughMinValues/TroughMinValues';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './SelectTroughList.messages';

export interface SelectedTroughListProps {
  trough: GlobalPrivateState['trough'];
  configuration: GlobalPrivateState['configuration'];
}

export class SelectedTroughListPartial extends React.Component<SelectedTroughListProps> {
  public render() {
    return (
      <div className="partial-trough-list">
        <div className="trough trough-selection pt-3">
          <div className="row">
            {this.selectedTrough && (
              <>
                <h4><span><FontAwesomeIcon icon={faCheck} /></span> <FormattedMessage {...MESSAGES.selectedTroughListButton} /></h4>
                <TroughMinValues />
                <SelectedTroughListItem trough={this.selectedTrough} />
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  private get selectedTrough(): TroughModel | undefined {
    const { trough } = this.props;
    return trough.result;
  }

}

export const SelectedTroughList = connect((state: GlobalPrivateState) => ({
  trough: state.trough,
  configuration: state.configuration,
}))(SelectedTroughListPartial);

export default SelectedTroughList;

